export default __webpack_public_path__ + "static/media/update_nameserver.90094021.svg";